import { FadeIn, Eyebrow } from "./primitives";

export const AboutHost = () => (
  <section id="about" data-testid="about-section" className="border-t border-bone/10">
    <div className="mx-auto max-w-6xl px-6 py-24">
      <div className="grid gap-16 md:grid-cols-[1fr_1.2fr] md:items-start">
        <FadeIn>
          <Eyebrow>Your host</Eyebrow>
          <div className="relative mt-8 aspect-[4/5] w-full max-w-sm overflow-hidden border border-bone/10" data-testid="host-portrait">
            <img
              src="https://images.pexels.com/photos/34921744/pexels-photo-34921744.jpeg"
              alt="Mel Masry, host of Reel vs Real"
              className="h-full w-full object-cover object-top grayscale"
              loading="lazy"
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-noir/80 via-transparent to-noir/20" />
            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-ruby/60" />
          </div>
          <h2 className="mt-8 font-display text-4xl font-light tracking-tight text-bone sm:text-5xl">
            Mel <span className="italic text-ruby">Masry</span>
          </h2>
          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 font-mono text-xs uppercase tracking-[0.25em] text-smoke">
            <span>Actor</span>
            <span className="text-ruby">/</span>
            <span>Coach</span>
            <span className="text-ruby">/</span>
            <span>Writer</span>
            <span className="text-ruby">/</span>
            <span>Host on Nile FM</span>
          </div>
          <a
            href="https://instagram.com/mmasry86"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="host-instagram-link"
            className="mt-8 inline-flex items-center gap-2 border border-bone/20 px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] text-bone transition-colors duration-300 hover:border-ruby hover:text-ruby"
          >
            Follow @mmasry86
          </a>
        </FadeIn>

        <FadeIn delay={0.15}>
          <p className="text-base font-light leading-relaxed text-zinc-400 sm:text-lg">
            Mel sits at the intersection of acting, coaching and writing — an
            understanding of performance, psychology and storytelling. Not
            analysing from theory, but from an understanding of the behaviour
            beneath performance.
          </p>
          <p className="mt-6 text-base font-light leading-relaxed text-zinc-400 sm:text-lg">
            The show speaks with calm authority and emotional intelligence —
            never over-performed, never a lecture. It feels like a late-night
            conversation: intimate, reflective, honest.
          </p>
          <p className="mt-6 text-base font-light leading-relaxed text-zinc-400 sm:text-lg">
            Reel vs Real is hosted by Mel on Nile FM.
          </p>
          <blockquote className="mt-12 border-l-2 border-ruby pl-8">
            <p className="font-display text-2xl font-light italic leading-snug text-bone sm:text-3xl">
              “Cinema doesn't just reflect relationships — it shapes
              expectations.”
            </p>
          </blockquote>
        </FadeIn>
      </div>
    </div>
  </section>
);
